export default {
  title: '{{company}} zaktualizowało Twój czas odbioru',
  title_on_site: '{{company}} zaktualizowało czas podania Twojego zamówienia',
  new_time_label: 'Nowy czas',
};
